import { useBrand } from '../components/ServerBrandProvider';
import { currentBrand } from '../config/branding';

export const useSafeBrand = () => {
  try {
    return useBrand();
  } catch {
    return {
      brand: currentBrand,
      loading: false,
    };
  }
};
